import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MaxLengthDirective } from './max-length.directive';

@NgModule({
  imports: [CommonModule, MaxLengthDirective],
  exports: [MaxLengthDirective],
})
export class MaxLengthModule {}
